import React from "react";

export const Testimonials = (props) => {
  return (
    <>
      <style>{`
        #testimonials {
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        #testimonials .container {
          width: 100%;
          max-width: 1170px;
          margin: 0 auto;
          padding: 0 15px;
          box-sizing: border-box;
        }
        #testimonials .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -15px;
          box-sizing: border-box;
        }
        #testimonials .col-md-4 {
          width: 100%;
          padding: 0 15px;
          box-sizing: border-box;
          margin-bottom: 24px;
        }
        #testimonials .testimonial {
          box-sizing: border-box;
        }
        #testimonials .testimonial-image img {
          width: 100%;
          max-width: 100%;
          height: auto;
          display: block;
        }
        #testimonials .testimonial-content p {
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        #testimonials .testimonial-product {
          font-size: 13px;
          color: #aaa;
          margin-top: 4px;
          font-style: italic;
        }

        @media (min-width: 992px) {
          #testimonials .col-md-4 {
            width: 33.3333%;
          }
        }

        @media (max-width: 767px) {
          #testimonials .col-md-4 {
            width: 100%;
          }
        }
      `}</style>

      <div id="testimonials">
        <div className="container">
          <div className="section-title text-center">
            <h2>What our clients say</h2>
          </div>
          <div className="row">
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-md-4">
                    <div className="testimonial">
                      <div className="testimonial-image">
                        <img src={d.img} alt="" />
                      </div>
                      <div className="testimonial-content">
                        <p>"{d.text}"</p>
                        <div className="testimonial-meta"> - {d.name} </div>
                        {d.product && (
                          <div className="testimonial-product">
                            🛒 {d.product}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>
    </>
  );
};